export default "__VITE_ASSET__DHiI1Z9E__"